import React from 'react';
import styled from 'styled-components';

const Loader = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  opacity: 0;

  transition: opacity 1s;

  &.fade-in {
    opacity: 1;
  }
`;

class FadeInImg extends React.Component {

  state = {
    className: undefined,
    src: undefined,
  };

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(prevProps) {
    if (this.props.src !== prevProps.src) {
      this.loadImage();
    }
  }

  loadImage = () => {

    // Reset:
    this.setState({
      className: undefined,
      src: undefined,
    });

    // Preload then fade in:
    let img = new Image();
    img.onload = () => {
      this.setState({
        src: this.props.src,
        className: "fade-in",
      });
    }

    // Trigger image load:
    img.src = this.props.src;
  }

  render() {
    return (
      <Loader src={this.state.src} className={this.state.className} />
    );
  }

}

export default FadeInImg;



// WEBPACK FOOTER //
// ./src/components/FadeInImg.js